import React from 'react';
import { Box, Divider, Link, Grid, useMediaQuery } from '@mui/material';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  forgetText: {
    font: "14px Work Sans",
    lineHeight: "30px",
    color: "#39A2DB",
    textDecoration: "none !important",
    maxHeight: "30px !important",
    marginTop: "10px !important",
    paddingLeft: "5px !important",
    cursor: "pointer",
    zIndex: 30,
    width: '135px',
    textAlign: 'center',
  },
});

export default function ExtraLinks() {
  const classes = useStyles();
  const matches300 = useMediaQuery("(max-width:300px)");

  return (
    <Box sx={{ width: '100%', margin: '27px 0 !important' }}>
      <Divider />
      <Grid item sx={{ 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'space-evenly',
        flexDirection: matches300 ? 'column': 'row' 
      }}>
        <Link href='http://support.inosio.com/' className={classes.forgetText}>
          Need Help?
        </Link>
      </Grid>
    </Box>
  )
}
